import keymirror from 'keymirror';

const STATES = keymirror({
    VIEW: null,
    PREVIEW: null,
    EDIT: null,
    SAVING: null,
    DISABLED: null,
});

export default STATES;
